import Vue from "vue";
import App from "./App.vue";
import VueGtm from "@gtm-support/vue2-gtm";
import router from "./router";
import store from "./store";
import VueTheMask from "vue-the-mask";
import "./plugins/axios";
const moment = require("moment");
require("moment/locale/pt-br");

Vue.config.productionTip = false;

Vue.use(VueTheMask);
Vue.use(require("vue-moment"), {
  moment
});

if (process.env.VUE_APP_GTM_ID) {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GTM_ID,
    defer: false,
    compatibility: false,
    nonce: "2726c7f26c",
    enabled: true,
    debug: process.env.NODE_ENV === "development",
    loadScript: true,
    vueRouter: router,
    trackOnNextTick: false
  });
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
